"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromptTemplate = void 0;
var create_entity_1 = require("../../utils/create-entity");
exports.PromptTemplate = {
  name: 'PromptTemplate',
  type: 'taxonomy',
  imageStyle: 'logo',
  imageInset: 2,
  useSites: true,
  table: {
    fields: {
      info: {
        weight: 1.5
      },
      type: {
        title: 'Type',
        weight: 1
      },
      sources: {
        weight: 1
      },
      orderNumber: {
        weight: 0.5,
        type: 'count',
        title: 'Order #'
      },
      gptModel: {
        title: 'Model',
        weight: 1
      }
    }
  },
  list: {
    resultsVariant: "table"
  },
  form: {
    modal: {
      maxWidth: "600px"
    },
    fieldSets: [{
      name: 'overview',
      label: 'Overview'
    }, {
      name: 'variables',
      label: 'Variables'
    }, {
      name: 'connections',
      label: 'Connections'
    }, {
      name: 'admin',
      label: 'Admin'
    }],
    fields: __assign(__assign({}, create_entity_1.entityStandardFormFields), {
      orderNumber: {
        type: 'int',
        recommended: false
      },
      template: {
        type: 'longText',
        description: 'The template for the prompt. The "Name" field of each {{PROMPT_VARIABLE}} specified in the Variables tab should be inserted into the template using placeholders of the form {Variable Name}, and the values given to those variables will replace those placeholders when users make queries based on this template.'
      },
      systemMessage: {
        type: 'linked',
        entityTypeName: 'SystemMessage',
        description: 'Define a {{SYSTEM_MESSAGE}} for this {{PROMPT_VARIABLE}}'
      },
      sources: {
        type: 'linkedMultiple',
        entityTypeName: 'CompletionSource',
        description: 'What sources should queries made using this {{PROMPT_TEMPLATE}} use by default? Note: {{PROMPT_VARIABLES}} can each override these sources individually for more granular control.'
      },
      variablesPrompt: {
        type: 'longText',
        description: 'Provide a prompt chat message to describe the user interface which collects variable values.',
        fieldSet: 'variables'
      },
      variables: {
        type: 'linkedTable',
        entityTypeName: 'PromptVariable',
        description: 'Provode details for the {{PROMPT_VARIABLES}} used inside this template. This binds the placeholders for variable names inside the template text with the user interface controls used to collect their values.',
        fieldSet: 'variables'
      },
      submitLabel: {
        type: 'text',
        fieldSet: 'variables',
        description: 'Provide a label for the button shown below the form, which submits the query to the GPT.'
      },
      languages: {
        type: 'linkedMultiple',
        entityTypeName: 'Language',
        fieldSet: 'variables',
        description: "Select the spoken languages the user can select for the response. If none are provided, there will be no selector shown, and the response will be English"
      },
      // useVectorStore: { type: 'boolean', recommended: false, description: 'Check this box to include the vector database store in query results for this template by default. Note: {{PROMPT_VARIABLES}} can each override this setting individually for more granular control.' },
      label: {
        type: 'text',
        recommended: false
      },
      type: {
        type: 'linked',
        entityTypeName: 'PromptTemplateType',
        description: 'What type of template is this? This should describe the action the user will take when using the template, and will be shown as a label above the label in template selector UIs.'
      },
      summary: {
        type: 'longText',
        description: 'Create a short description to show on the card for this template, which is shown in the Templates tab menu, and when the template is selected.'
      },
      description: {
        type: 'longText',
        recommended: false
      },
      hideInTemplateList: {
        type: 'boolean',
        recommended: false,
        description: 'Check this box to hide this template from the Templates listing in any websites using them.'
      },
      icons: {
        type: 'linkedMultiple',
        entityTypeName: 'Icon',
        description: 'Which {{ICONS}} should be used to represent this {{PROMPT_TEMPLATE}}?'
      },
      pages: {
        type: 'linkedMultiple',
        entityTypeName: 'Page',
        fieldSet: 'connections',
        description: 'Which {{PAGES}} should this {{PROMPT_TEMPLATE}} be made available on? Note: if none are selected, all {{PAGES}} will be assumed.'
      },
      posts: {
        type: 'linkedMultiple',
        entityTypeName: 'Post',
        fieldSet: 'connections',
        description: 'Which {{POSTS}} should this {{PROMPT_TEMPLATE}} be made available on? Note: if none are selected, all {{POSTS}} will be assumed.'
      },
      trends: {
        type: 'linkedMultiple',
        entityTypeName: 'Trend',
        fieldSet: 'connections',
        description: 'Which {{TRENDS}} should this {{PROMPT_TEMPLATE}} be made available on? Note: if none are selected, all {{TRENDS}} will be assumed.'
      },
      topics: {
        type: 'linkedMultiple',
        entityTypeName: 'Topic',
        fieldSet: 'connections',
        description: 'Note: if none are selected, all {{TOPICS}} will be assumed.'
      },
      subTopics: {
        type: 'linkedMultiple',
        entityTypeName: 'SubTopic',
        fieldSet: 'connections',
        description: 'Note: if none are selected, all {{SUB_TOPICS}} will be assumed.'
      },
      gptModel: {
        type: 'linked',
        entityTypeName: 'GptModel',
        fieldSet: 'admin',
        description: 'Which GPT Model should this {{PROMPT_TEMPLATE}} use when querying?'
      }
    })
  },
  autoRoutes: ['list', 'create', 'update']
};